// -- import * as _ from "lodash-es"
import * as _date from "date-fns"
import Vue from "vue"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "sPlant_OrderForecast"

const create = function () { }
const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      type: "button",
      button: {
        type: "text"
      },
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "ForecastSalesId",
      label: "平台预测订单编码",
      sortable: true
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "CustAccountId",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "CustAccountName",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "TEC_FinalCustAccount",
      label: "最终客户",
      sortable: true
    },
    {
      key: "TEC_FinalCustAccount_Name",
      label: "最终客户名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "SEI_BigCustomerNumber",
      label: "TOP客户组",
      sortable: true,
      thStyle: {
        width: "10rem"
      },
      type: "short"
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "InclTax",
      label: "价格包括销售税",
      sortable: true
    },
    {
      key: "MainContactWorker",
      label: "销售经理",
      sortable: true
    },
    {
      key: "SEI_SalesGroup",
      label: "销售团队",
      sortable: true
    },
    {
      key: "SegmentId",
      label: "细分市场",
      sortable: true
    },
    {
      key: "description",
      label: "备注",
      sortable: true
    },
    {
      key: "create_by",
      label: "创建人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    {
      key: "create_at",
      label: "创建时间",
      sortable: true,
      type: "datetime"
    },
    {
      key: "update_by",
      label: "修改人",
      sortable: true,
      formatter: (value, key, item) => {
        return item.update_by_username
      }
    },
    {
      key: "update_at",
      label: "修改时间",
      sortable: true,
      type: "datetime"
    },

    {
      key: "SFApprover",
      label: "待审批人",
      sortable: true
    },
    {
      key: "fcCheckSFApproved",
      label: "订单审批",
      sortable: true,
      type: "state",
      state_control: "fcCheckSFApproved",
      other_type_key: "is_email_send",
      context: ["待审批", "已审批", "审批中"]
    },
    {
      key: "SFApprovedState",
      label: "订单审批状态名称",
      sortable: true,
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId",
      formatter: (value, key, item) => {
        if (item.fcCheckSFApproved) {
          item.SFApprovedState = "已审批"
          return "已审批"
        } else if (item.is_email_send) {
          item.SFApprovedState = "审批中"
          return "审批中"
        } else {
          item.SFApprovedState = "待审批"
          return "待审批"
        }
      }
    }
  ],
  detail_fields: [
    {
      key: "seq",
      label: "行号",
      sortable: true,
      width: "40px"
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "SalesQty",
      label: "数量",
      sortable: true,
      editable: true,
      type: "just_number"
    },
    {
      key: "StartDate",
      label: "装运日期",
      sortable: true,
      editable: true,
      type: "date"
    },
    {
      key: "SalesUnitId",
      label: "单位",
      sortable: true
    },
    {
      key: "is_invent_ready",
      label: "备料",
      sortable: true,
      editable: true,
      type: "boolean"
    },
    {
      key: "ModelId",
      label: "预测模型",
      editable: true
    },
    {
      key: "SEI_ForecastSalesType",
      label: "预测类型",
      editable: true,
      type: "textarea"
    },
    {
      key: "SEI_ForecastAccuracy",
      label: "预测准确率(%)",
      editable: true,
      type: "number"
    },
    {
      key: "description",
      label: "备注",
      sortable: true,
      editable: true,
      type: "textarea"
    },
    {
      key: "RetailVariantId",
      label: "变形编号",
      sortable: true,
      // editable: true,
      width: "8rem",
      thStyle: {
        display: "none"
      },
      tdClass: "no-shown-RetailVariantId"
    },
    {
      key: "SEI_DimensionFG",
      label: "FG维度",
      sortable: true
    },
    {
      key: "SEI_CP_ReplenishmentCommit",
      label: "补货计划",
      sortable: true
    },
    {
      key: "WeekName",
      label: "周的名称",
      sortable: true
    },
    {
      key: "valid_remain",
      label: "剩余派发数量",
      sortable: true,
      type: "number"
    }

  ],
  inventTable_fields: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      width: "10rem"
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "TEC_CustAccount",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "DW_CustName",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "8rem"
      }
    },

    {
      key: "TEC_NetArea",
      label: "净面积",
      sortable: true,
      type: "number"
    },
    {
      key: "TEC_Weight",
      label: "单位重量",
      sortable: true,
      type: "number"
    },
    {
      key: "DW_InventUnitId",
      label: "单位",
      sortable: true
    },
    {
      key: "SEI_DimensionFG",
      label: "FG维度",
      sortable: true
    }
    // {
    //   key: "modifiedDateTime",
    //   label: "修改时间",
    //   type: "datetime",
    //   thStyle: { width: "5rem" }
    // }
  ]
}

const dataForm = {
  id: "",
  ForecastSalesId: "", //	预测订单id
  CustAccountId: "", //	客户账户
  TEC_FinalCustAccount: "", //	最终客户
  dataAreaId: "", //	公司
  ModelId: "", //	模型
  CurrencyCode: "",
  InclTax: "",
  MainContactWorker: "", //销售经理
  SEI_SalesGroup: "", //销售团队
  SegmentId: "", //细分市场
  SEI_ForecastSalesType: "", //	预测模型(要移到line)
  SEI_ForecastAccuracy: "", //预测准确率(要移到line)
  description: "" //	备注
}

const dataItemForm = {
  id: "",
  order_forecast_id: "",
  ForecastSalesId: "",
  ItemId: "", //物料
  NameAlias: "", //物料名称
  SalesQty: "", //预测数量
  SalesUnitId: "", //单位
  Currency: "", //币种
  StartDate: "", //日期
  Active: "", //有效
  is_invent_ready: "", //是否可以根据当前预测备料
  SEI_ForecastSalesType: "", //	预测模型
  SEI_ForecastAccuracy: "", //预测准确率
  RetailVariantId: "",
  VariantName: "",
  valid_remain: 0,
  description: "",
  ModelId: "", //预测模型
  seq: 0
}

///前端验证
const rules = {
  CustAccountId: [
    {
      required: true,
      message: "请选择客户账户",
      trigger: "change"
    }
  ],
  TEC_FinalCustAccount: [
    {
      required: true,
      message: "请选择最终客户",
      trigger: "change"
    }
  ],
  InvoiceAccount: [
    {
      required: true,
      message: "请选择开票账户",
      trigger: "change"
    }
  ],
  dataAreaId: [
    {
      required: true,
      message: "请选择公司",
      trigger: "change"
    }
  ]
}

const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
const methods = {
  //复制预测订单
  async copyOrderForecast(_params) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "CopySalesForcast",
      {},
      {}
    )
    let _fields = []

    let result = await code_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()
    //
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //#region 订单主档相关
  ///get salesorder
  async getData(_params) {
    let _fields = _.map(fields.default, "key")
    _fields.push("fcGetSFApprover(t.id)")
    _fields.push("fcCheckSFApproved(t.id)")
    _fields.push("is_email_send")
    _fields.push("fcCheckIsOrderForecastAllDispatched(t.id)")

    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()
    //
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///save data
  async saveData(_params) {
    let _actions = []
    let _new = _.cloneDeep(_params)
    let _username = _new.documentCreateByUsername
    ///保存
    if (!_.isInteger(_params.id)) {
      delete _new.documentCreateByUsername
      delete _new.id

      const code_biz_data = new biz_data_helper.base_entity_helper(
        "get_seq",
        {},
        {}
      )
      //获取code
      let _p = {
        type: "CFC",
        date: _date.format(new Date(), "yyyy-MM-dd")
      }
      _actions.push(
        code_biz_data
          .execAction({
            params: _p,
            fields: ["seq"]
          })
          .action({
            output_last_item_map: {
              seq: "ForecastSalesId"
            }
          })
      )
      _actions.push(
        biz_data
          .insertAction({
            params: _new,
            fields: _.map(fields.default, "key")
          })
          .action({
            mixin_last_item_map: {
              ForecastSalesId: "ForecastSalesId"
            },
            output_last_item_map: {
              id: "itemId"
            }
          })
      )
    } else {
      delete _new.documentCreateByUsername
      _new.is_email_send = 0
      _actions.push(
        biz_data
          .updateAction({
            params: _new,
            fields: _.map(fields.default, "key")
          })
          .action({
            output_last_item_map: {
              id: "itemId"
            }
          })
      )
    }

    ///审批
    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus",
      {},
      {}
    )

    let credit_form = {
      itemId: "",
      documentType: "SalesForcast",
      approveType: "", //审批类型："" ---普通审批
      documentCreateByUsername:
        Vue.prototype.$global.global_data.local_username,
      salesOrderAmountCNY: 0
    }

    _actions.push(
      so_approve_biz_data
        .execAction({
          params: credit_form,
          fields: ["id"]
        })
        .action({
          mixin_last_item_map: {
            itemId: "itemId"
          }
        })
    )

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let _list = null
      let _rt = _.filter(result.data.BatchResult.Actions, function (t) {
        return t.Code.indexOf("sPlant_OrderForecast") > -1
      })
      if (
        _rt &&
        _rt[0].Result &&
        !_.isNull(_rt[0].Result) &&
        _rt[0].Result.Data &&
        !_.isNull(_rt[0].Result.Data) &&
        _rt[0].Result.Data.length > 0
      ) {
        _list = _rt[0].Result.Data[0]
      }
      console.log(_list)
      return _list
    } else {
      return null
    }
  },
  ///del salesorder
  async deleteData(items) {
    let _actions = []

    let check_del_biz_data = new biz_data_helper.base_entity_helper(
      "CheckIfExistsSalesForcastLine",
      create,
      descriptor
    )
    let del_biz_data = new biz_data_helper.base_entity_helper(
      "delete_order_forecast",
      create,
      descriptor
    )
    let cancel_email_biz_data = new biz_data_helper.base_entity_helper(
      "cancel_email_send",
      {},
      {}
    )
    _.each(items, t => {
      _actions.push(
        check_del_biz_data
          .execAction({
            params: {
              itemId: t.id
            },
            fields: ["has_SalesLine"]
          })
          .action({
            output_last_item_map: {
              has_SalesLine: "has_SalesLine"
            }
          })
      )
      _actions.push(
        del_biz_data
          .execAction({
            params: {
              id: t.id
            },
            fields: ["id"]
          })
          .action({
            rollback_when: {
              has_SalesLine: {
                "=": 1
              }
            }
          })
      )
      ///取消邮件
      _actions.push(
        cancel_email_biz_data
          .execAction({
            params: {
              type: "sf",
              idx: _.toString(t.ForecastSalesId)
            }
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },

  ///approved salesorder
  async approveData(items) {
    const update_status_biz_data = new biz_data_helper.base_entity_helper(
      "update_approve_status",
      {},
      {}
    )
    let _actions = []
    _.each(items, t => {
      let _action = {}
      _actions.push(
        update_status_biz_data
          .execAction({
            params: {
              IsApproved: t.is_approved == true ? 1 : 0,
              ApproveBy: t.username,
              status_id: t.id
            },
            fields: ["is_update_ok"]
          })
          .action({
            output_last_item_map: {
              is_update_ok: "is_update_ok"
            }
          })
      )
      _action = {
        rollback_when: {
          is_update_ok: {
            "=": 1
          }
        }
      }
      ///反审时将邮件状态修改为未发送
      if (!t.is_approved) {
        _actions.push(
          biz_data
            .updateAction({
              params: {
                id: t.order_forecast_id,
                is_email_send: 0
              }
            })
            .action(_action)
        )
      }
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let _is_ok = true
      let _result_filter = _.filter(result.data.BatchResult.Actions, {
        Code: "data/e/update_approve_status"
      })
      if (_result_filter && _result_filter.length > 0) {
        _.each(_result_filter, t => {
          if (t.Result.Data[0][0].is_update_ok == 1) {
            _is_ok = false
          }
        })
      }
      return _is_ok
    } else {
      return false
    }
  },

  //#endregion

  //#region 订单明细相关
  ///查询已经派单数量
  async getDispatchedQty(SFId) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "getTotalDispatchQtyForcast",
      create,
      descriptor
    )
    let result = await item_biz_data
      .execAction({
        params: {
          SalesForecastId: SFId
        },
        fields: ["totalDispatchedQty"]
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///get so items
  async getItemData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast_Line",
      create,
      descriptor
    )
    let _fields = _.map(fields.detail_fields, "key")
    _fields.push("id")
    _fields.push("ForecastSalesId")
    _fields.push("order_forecast_id")
    let result = await item_biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getItemDataSql(_params) {
    const line_biz_data = new biz_data_helper.base_entity_helper(
      "get_orderforecast_line",
      {},
      {}
    )
    let _fields = _.map(fields.detail_fields, "key")
    _fields.push("id")
    _fields.push("ForecastSalesId")
    _fields.push("order_forecast_id")
    let result = await line_biz_data
      .execAction({
        params: _params,
        fields: _fields
      })
      .run()
    // let _fields = _.map(fields.default, "key");
    // _fields.push("id");
    // _fields.push("order_forecast_id");
    // let result = await biz_data
    //   .selectAction({
    //     params: _params,
    //     fields: _fields
    //   })
    //   .run();
    //
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },

  ///save so items
  async saveItems(items) {
    let add_list = [],
      update_list = []
    let sf_main = {
      id: "",
      documentCreateByUsername: ""
    }
    _.each(items, t => {
      sf_main.id = t.order_forecast_id
      sf_main.documentCreateByUsername = t.documentCreateByUsername

      delete t.SEI_DimensionFG
      delete t.documentCreateByUsername
      let _new = _.cloneDeep(dataItemForm)
      for (var i in _new) {
        _new[i] = t[i]
      }
      if (_.isInteger(t.id)) {
        update_list.push(_new)
      } else {
        delete _new.id
        add_list.push(_new)
      }
    })

    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast_Line",
      create,
      descriptor
    )
    let check_biz_data = new biz_data_helper.base_entity_helper(
      "CheckIfCanModifySalesForcastLine",
      {},
      {}
    )
    let batch_actions = []
    if (add_list.length > 0) {
      batch_actions.push(
        item_biz_data
          .insertAction({
            params: add_list,
            fields: ["id"]
          })
          .action({
            output_last_item_map: {
              id: "order_forecast_id"
            }
          })
      )
    }

    if (update_list.length > 0) {
      _.each(update_list, t => {
        batch_actions.push(
          check_biz_data
            .execAction({
              params: {
                SalesForcastLineId: t.id,
                action: "update",
                inputQty: t.SalesQty
              },
              fields: ["allowed"]
            })
            .action({
              output_last_item_map: {
                allowed: "allowed"
              }
            })
        )
        batch_actions.push(
          item_biz_data
            .updateAction({
              params: t,
              fields: ["id"]
            })
            .action({
              rollback_when: {
                allowed: {
                  "=": false
                }
              }
            })
        )
      })
    }
    batch_actions.push(
      biz_data
        .updateAction({
          params: {
            id: sf_main.id,
            is_email_send: 0
          },
          fields: ["id"]
        })
        .action({})
    )

    ///审批
    let so_approve_biz_data = new biz_data_helper.base_entity_helper(
      "sp_updateApproveStatus",
      {},
      {}
    )

    let credit_form = {
      itemId: sf_main.id,
      documentType: "SalesForcast",
      approveType: "", //审批类型："" ---普通审批
      documentCreateByUsername: sf_main.documentCreateByUsername,
      salesOrderAmountCNY: 0
    }

    batch_actions.push(
      so_approve_biz_data
        .execAction({
          params: credit_form,
          fields: ["id"]
        })
        .action({})
    )

    ///查询当前保存的订单数据
    let _fields = _.map(fields.default, "key")
    _fields.push("fcGetSFApprover(t.id)")
    _fields.push("fcCheckSFApproved(t.id)")
    _fields.push("is_email_send")
    batch_actions.push(
      biz_data
        .selectAction({
          params: {
            id: sf_main.id
          },
          fields: _fields
        })
        .action({})
    )

    let result = await api.query_batch({
      actions: batch_actions
    })
    //
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  ///del so items
  async deleteItemData(items) {
    let _actions = []
    let check_biz_data = new biz_data_helper.base_entity_helper(
      "CheckIfCanModifySalesForcastLine",
      {},
      {}
    )
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "sPlant_OrderForecast_Line",
      create,
      descriptor
    )

    _.each(items, t => {
      _actions.push(
        check_biz_data
          .execAction({
            params: {
              SalesForcastLineId: t.id,
              action: "delete",
              inputQty: t.SalesQty
            },
            fields: ["allowed"]
          })
          .action({
            output_last_item_map: {
              allowed: "allowed"
            }
          })
      )
      _actions.push(
        item_biz_data
          .deleteAction({
            params: {
              id: t.id
            }
          })
          .action({
            rollback_when: {
              allowed: {
                "=": false
              }
            }
          })
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return false
    }
  },
  //#endregion
  ///检查能否反审
  async checkUnApprove(items) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "check_is_salesforecast_dispatched",
      {},
      {}
    )
    let _actions = []
    let _params = []
    _.each(items, t => {
      _params.push({
        SalesForecastId: t.id
      })
    })
    _actions.push(
      code_biz_data
        .execAction({
          params: _params,
          fields: ["if_can_unapprove", "SalesForecastId"]
        })
        .action({})
    )
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let _p = {
        state: true,
        data: [],
        message: ""
      }
      let rt_actions = result.data.BatchResult.Actions[0]
      if (
        rt_actions.Result &&
        rt_actions.Result.Data &&
        rt_actions.Result.Data.length > 0
      ) {
        _.each(rt_actions.Result.Data, t => {
          if (t[0].if_can_unapprove == 0) {
            _p.state = false
            _p.data.push(t[0].SalesForecastId)
          }
        })
      }
      if (!_p.state) {
        _p.message =
          "订单编号：" + _.join(_p.data, "，") + "，已派单不能被删除！"
      }
      return _p
    } else {
      return null
    }
  }
}
export { biz_data, dataForm, dataItemForm, fields, methods, rules };

